import PropTypes from "prop-types";
import React from "react";
import { graphql } from "gatsby";
import { ThemeContext } from "../layouts";
import Article from "../components/Article";
import Headline from "../components/Article/Headline";
import Seo from "../components/Seo";

const ContactPage = props => {
  const {
    data: {
      site: {
        siteMetadata: { facebook }
      }
    }
  } = props;

  return (
    <React.Fragment>
      <ThemeContext.Consumer>
        {theme => (
          <Article theme={theme}>
            
            <header>
              <Headline title="The Team" theme={theme} />
            </header>
            <div className="member">
              <div className="member-name">Jack Silberman - Ph.D.</div>
              
              <div className="member-title">Academic Advisor</div>
              <div className="member-picture-container">
                <img src="/team/jack.jpg" />
              </div>
              <div className="resume-link">
                <a href="mailto:jacks@eng.ucsd.edu">Email</a> |{" "}
                <a href="https://www.linkedin.com/in/jacksilberman/">Linkedin</a>
              </div>
              
              <div className="member-description">
                Jack Silberman has over 20 years of experience in automation and robotics. He
                started working in robotics while pursuing his B.S. in electrical engineering. Dr.
                Silberman did robotics post graduate work in England and holds a master's degree
                from PUC-Rio in mechanical engineering and a Ph.D. from Carnegie Mellon University
                where his research was on mobile field robotics reliability. Dr. Silberman has
                worked in educational robotics, NASA sponsored mobile field robotics, semiconductor
                automation, biotech and medical devices. Currently, Dr. Silberman is the commercial
                QA area manager for Canada and Latin America with Abbott Diabetes Care (ADC), and a
                lecturer at UC San Diego in mechanical and aerospace engineering.
              </div>
            </div>

           
            <div className="member">
              <div className="member-name">Haoru Xu - Electrical Engineering</div>
              <div className="member-title">President of Triton-Ai - Undergraduate</div>
              <div className="member-picture-container">
                <img src="/team/haoru.jpg" />
              </div>
              <div className="resume-link">
                <a href="/resumes/Haoru_Xue.pdf">Resume</a> |{" "}
                <a href="mailto:hxue@ucsd.edu">Email</a> |{" "}
                <a href="https://www.linkedin.com/in/haoru-xue/">Linkedin</a> |{" "}
                <a href="https://github.com/FrostXue">Github</a> |{" "}
                <a href="http://triton-ai.eng.ucsd.edu/virtual-tournament/">1st place Virtual Tournament</a>


              </div>
              <div className="member-description">
                Haoru Xue is a junior Electeical Engineering undergrad with a depth in Machine
                Learning and Controls. Since childhood he has always been fascinated with robotics
                and autonomous vehicles and enjoyed playing with LEGO robots. As he grows up he
                continues to explore this field with embedded systems, machine learning and computer
                vision. He wishes to have a career in autonomous driving and machine learning as
                well. He loves using the team name Critical Error in all kind of competitions
                because that kind of foreshadows what always happens to him. In his spare time he is
                an enthusiastic CSGO player.
              </div>
            </div>

            <div className="member">
              <div className="member-name">Leeor Nehardea - Computer Engineering</div>
              <div className="member-title">Vice President of Triton-Ai - Undergraduate</div>
              <div className="member-picture-container">
                <img src="/team/leeor.jpg" />
              </div>
              <div className="resume-link">
                <a href="mailto:lneharde@ucsd.edu">Email</a> |{" "}
                <a href="https://www.linkedin.com/in/leeor-nehardea-151ab5b0/">Linkedin</a> 
              </div>
              <div className="member-description">
              Leeor Nehardea is a 5th-year Computer Engineering student interested in machine learning and artificial intelligence. In addition to school, he took a nine-months data science and machine learning Bootcamp. After graduation, Leeor plans to continue to a Master's program in autonomous cars and computer vision, and apply his knowledge to help bring the dream of self-driving cars to our everyday life. 
              </div>
            </div>

            <div className="member">
              <div className="member-name">Lavita Zuo - Computer Engineering (Minor: Business)</div>
              <div className="member-title">AS Events Coordinating Officer - Undergraduate</div>

              <div className="member-picture-container">
                <img src="/team/lavita.jpg" />
              </div>
              <div className="resume-link">
                <a href="mailto:x5zuo@ucsd.edu">Email</a> |{" "}
                <a href="/resumes/Lavita_Zuo_Resume.pdf">Resume</a> |{" "}
                <a href="https://www.linkedin.com/in/lavita-zuo-532106186/">Linkedin</a> 
              </div>
              <div className="member-description">
              Driven by my family members' surgery anxiety, I got interested in surgical robotics systems such as the Da Vinci Surgeon. I'm hoping to advance robotics in healthcare and make surgical robots more affordable for people in need. In my spare time, I like reading, cooking, hiking, and watching Netflix. Fun fact about me: My high jump record was 1.48 m when I was 12.
              </div>
            </div>

            <div className="member">
              <div className="member-name">Songyu Lu - Computer Engineering</div>
              <div className="member-title"> TESC Events Coordinating Officer - Undergraduate</div>

              <div className="member-picture-container">
                <img src="/team/lu.jpg" />
              </div>
              <div className="resume-link">
                <a href="mailto:sol009@ucsd.edu">Email</a> |{" "}
                <a href="https://www.linkedin.com/in/songyu-lu-b6803b198/">Linkedin</a> |{" "}
                <a href="https://github.com/Lu-Songyu">Github</a> 
              </div>
              <div className="member-description">
              Songyu Lu is a 2nd-year computing engineering student focused on software development, machine learning and artificial intelligence. He is also involved in multiple research labs and ECE undergrad student council. Lu is passionate about meeting new friends and developing cool projects with them. And his favorite quote is from the world's best boss Michael Scott- "Would I rather be feared or loved? Easy. Both. I want people to be afraid of how much they love me. That's right”. 
              </div>
            </div>



            <div className="member">
              <div className="member-name">Andrew Britten - B.S. Electrical Engineering</div>
              <div className="member-title">Cofounder - Club Operations Advisor - Alumni</div>
              <div className="member-picture-container">
                <img src="/team/drew.jpg" />
              </div>
              <div className="resume-link">
                <a href="/resumes/Andrew_Britten.pdf">Resume</a> |{" "}
                <a href="mailto:abritten@ucsd.edu">Email</a> |{" "}
                <a href="https://www.linkedin.com/in/andrew-britten-354883a5/">Linkedin</a> |{" "}
                <a href="https://github.com/abritten">Github</a>
              </div>
              <div className="member-description">
                Andrew Britten is a Navy submarine veteran that graduated UCSD in 2020 and is specialized in machine learning.
                He is one of the original cofounders of Triton-Ai and provides additional research on Nvidia JetRacer as well as Donkeycar comparisons. Andrew has experience in medical devices such as Carefusion ventilators and ultrasound equipment. Andrew is also the cofounder of Triton Tutors at UCSD.
              </div>
            </div>



            <div className="member">
              <div className="member-name">Ian Delaney - B.S. Mechanical Engineering</div>
              <div className="member-title">Technician Member - Alumni</div>
              <div className="member-picture-container">
                <img src="/team/ian.jpg" />
              </div>
              <div className="resume-link">
                <a href="mailto:ianjdelaney@gmail.com">Email</a> |{" "}
                <a href="https://www.linkedin.com/in/ianjdelaney/">Linkedin</a> 
              </div>
              <div className="member-description">
                Ian Delaney graduated from UCSD in 2019 with B.S. Mechanical Engineering. Ian has
                great experience and passion for increasing vehicle performance, gained while
                competing in the sport of Mototrials as a sponsored rider. The Jacobs School of
                Engineering allowed Ian many opportunities to develop electro-mechanical technical
                skills, including rapid prototyping and control system design. After interning for
                Tesla and the US Air Force, Ian now works as a Systems Engineer at Viasat in
                Carlsbad. Ian thoroughly enjoys solving problems and adding new system capabilities,
                utilizing the mechatronics-based skill set he developed while a student at UCSD.
              </div>
            </div>


            <div className="member">
              <div className="member-name">Nathan Perkins - B.S. CS (Oregon State University) <br></br> B.S. Forensic Biology (CSU Sacramento)</div>
              <div className="member-title">Technician Member - Embedded Systems Engineering Cert (UCSD)</div>

              <div className="member-picture-container">
              <img src="/team/nathan.jpg" />
              </div>
              <div className="resume-link">
              <a href="/resumes/Nathan_Perkins_Resume.pdf">Resume</a> |{" "}
              <a href="mailto:nperkins487@gmail.com">Email</a> |{" "}
              <a href="https://www.linkedin.com/in/nathan-perkins-3656086b/">Linkedin</a> |{" "}
              <a href="https://github.com/nathanperkins/">Github</a>
              </div>
              <div className="member-description">
                Nathan is a professional software engineer working at <a href="https://www.loon.com//">Loon</a>,
                 a graduated <a href="https://x.company/">Google X </a> 
                 project that provides cell phone service in rural areas and during disasters using a networked system of stratospheric balloon platforms. He is passionate about networking, cloud computing and embedded systems. At Triton-AI, he is leading a team that is using <a href="https://www.ros.org/">ROS </a>
                  as a platform for robots competing in the <a href="https://f1tenth.org/">F1Tenth</a> autonomous races.
              </div>
            </div>


            <div className="member">
              <div className="member-name">Felipe Diaz - Certification on Embedded System Engineering</div>
              <div className="member-title">Technician Member</div>
              <div className="member-picture-container">
                <img src="/team/felipe.png" />
              </div>
              <div className="member-description">
              Felipe Diaz is part of our Community members. As part of his 2020 UCSD Certification on Embedded System Engineering, he attended the Winter-2020 Introduction to Autonomous Vehicles class and thanks to Professor Jack, become interested in the autonomous cars AI potential of the club.
Planning on sticking around until autonomous car races can be live again.
Main areas of interest are autonomous vehicles, image-based recognition, vision systems, collaborative robotics with embedded metrology and predictive in-process control analysis.
              </div>
            </div>


            <div className="member">
              <div className="member-name">Jonathan Goenadibrata - Mechanical Engineering</div>
              <div className="member-title">Technician member - Graphics designer - Undergraduate</div>

              <div className="member-picture-container">
              <img src="/team/jonathan.jpg" />
              </div>
              <div className="resume-link">
              <a href="/resumes/Resume_Jonathan_Goenadibrata.pdf">Resume</a> |{" "}
              <a href="mailto:jgoenadi@ucsd.edu">Email</a> |{" "}
              <a href="https://www.linkedin.com/in/jonathangoenadibrata/">Linkedin</a> |{" "}
              <a href="http://triton-ai.eng.ucsd.edu/summer-virtual-tournament/">1st place Virtual Tournament</a>
              </div>
              <div className="member-description">
              Hi! I’m Jonathan and I’m a future Mechanical Engineer interested in anything robotics. I love exploring new things and and getting to know new people. My hobbies varies from playing games to music to graphic designs!
              </div>
            </div>


            <div className="member">
              <div className="member-name">Zekai Chen - Electrical Engineering</div>
              <div className="member-title">Technician Member - Undergraduate</div>

              <div className="member-picture-container">
                <img src="/team/zekai.jpg" />
              </div>
              <div className="resume-link">
                <a href="mailto:zechen@ucsd.edu">Email</a>
              </div>
              <div className="member-description">
              Zekai is a second year undergraduate at UC San Diego pursuing a major in Electrical Engineering. He finds autonomous driving very interesting after he took ECE 5 so he wants to enhance his knowledge of machine learning and autonomous driving and then put what he has learned into research and competition in the future.
              </div>
            </div>


            <div className="member">
              <div className="member-name">Ryan Dunn - B.S. Aerospace Engineering</div>
              <div className="member-title">Technician Member - Undergraduate</div>

              <div className="member-picture-container">
                <img src="/team/ryandunn.jpeg" />
              </div>
              <div className="resume-link">
                <a href="mailto:rcdunn@ucsd.edu">Email</a> |{" "}
                <a href="http://linkedin.com/in/ryandunn729">Linkedin</a>
              </div>
              <div className="member-description">
              I am a first-generation 3rd year university student. Growing up I've always loved to do puzzles and solve problems. I play with rubik's cubes, chess, checkers, sudoku, and really enjoy math. In my career, I want to help solve the puzzles of the future: sustainability and automation of the transportation industries. In my spare time I'm an active road cyclist and enjoy exploring the views in San Diego.
              </div>
            </div>


            <div className="member">
              <div className="member-name">Nhan Pham - Computer Engineering</div>
              <div className="member-title">Technician member - Undergraduate</div>

              <div className="member-picture-container">
              <img src="/team/nham.jpg" />
              </div>
              <div className="resume-link">
              <a href="/resumes/nham_pham_resume.pdf">Resume</a> |{" "}
              <a href="mailto:n2pham@ucsd.edu">Email</a> |{" "}
              <a href="https://www.linkedin.com/in/nhan-c-pham/">Linkedin</a>
              </div>
              <div className="member-description">
                I am a 3rd-year university student. I enjoy playing video games, reading, and especially working out. I am interested in Machine Learning and Artificial Intelligence. I am always looking to learn new things which is why the first thing I did was join Triton Ai. Can’t wait to see what they have to offer and the projects I will be doing!!!
              </div>
            </div>

            <div className="member">
              <div className="member-name">Peter Stratton - Computer Science Engineering</div>
              <div className="member-title">Technician Member - Undergraduate</div>

              <div className="member-picture-container">
              <img src="/team/peter.JPG" />

              </div>
              <div className="resume-link">
              <a href="/resumes/peter_stratton_resume.pdf">Resume</a> |{" "}
              <a href="mailto:pstratto@ucsd.edu">Email</a> |{" "}
              <a href="https://www.linkedin.com/in/peter-stratton-48b4517b/">Linkedin</a>
              </div>
              <div className="member-description">
              I'm a 3rd year student at UCSD, majoring in Computer Science and minoring in Mathematics. I'm interested in pursuing a graduate degree in Computer Science, and my research interests include applications of Filtering and SLAM systems in robotics, as well as Reinforcement Learning applications in robotics and Electronic Design Automation tools, both of which I'm developing through my Research Assistant position at the UCSD Existential Robotics Laboratory, my involvement with Triton AI, and my internship with MediaTek. In my free time, I enjoy surfing, munching on California burritos, and playing Minecraft.
              </div>
            </div>



            <div className="member">
              <div className="member-name">Ali Zaidi - Electrical Computer Engineering</div>
              <div className="member-title">Technician Member - Undergraduate</div>

              <div className="member-picture-container">
              <img src="/team/ali.png" />
              </div>
              <div className="resume-link">
              <a href="mailto:mazaidi@ucsd.edu">Email</a>
              
              </div>
              <div className="member-description">

              </div>
            </div>


            <div className="member">
              <div className="member-name">Ivan Ferrier - B.S. Electrical Computer Engineering</div>
              <div className="member-title">Technician Member - Alumni</div>

              <div className="member-picture-container">

              </div>
              <div className="resume-link">
              <a href="mailto:iferrier@ucsd.edu">Email</a>
              
              </div>
              <div className="member-description">

              </div>
            </div>

            <header>
              <Headline title="Triton-Ai Ambassadors" theme={theme} />
            </header>


            <div className="member">
              <div className="member-name">Gaurav Parmar - B.S. Computer Science</div>
              <div className="member-title">Triton-Ai Ambassador Carnegie Mellon University  - Alumni</div>
              <div className="member-picture-container">
                <img src="/team/gaurav.png" />
              </div>
              <div className="resume-link">
                <a href="/resumes/Gaurav_Parmar.pdf">Resume</a> |{" "}
                <a href="mailto:gparmar@ucsd.edu">Email</a> |{" "}
                <a href="https://www.linkedin.com/in/parmargaurav/">Linkedin</a> |{" "}
                <a href="https://github.com/GaParmar">Github</a> |{" "}
                <a href="http://triton-ai.eng.ucsd.edu/gaurav-virtual-tournament/">Grand Prix Participant</a>

              </div>
              <div className="member-description">
                I am a fourth year undergraduate student at University of California, San Diego. I
                am pursuing a major in Computer Science (with honors) along with a double minor in
                Cognitive Science and Mathematics. My research interests include Computer Vision,
                Machine Learning and Robotics.
              </div>
            </div>


            <div className="member">
              <div className="member-name">Steven Chen - Computer Engineering</div>
              <div className="member-title">Triton-Ai Ambassador UC Berkeley</div>

              <div className="member-picture-container">

              </div>
              <div className="resume-link">
              <a href="mailto:stevenfxchen@berkeley.edu">Email</a>
              
              </div>
              <div className="member-description">

              </div>
            </div>


            <header>
              <Headline title="Archive Team" theme={theme} />
            </header>
            

            <div className="member">
              <div className="member-name">Ehsan Ziaeikajbaf - B.S. Electrical Engineering</div>
              <div className="member-title">Cofounder - Principal Council Member - Graduate Student</div>
              <div className="member-picture-container">
                <img src="/team/ehsan.jpg" />
              </div>
              <div className="resume-link">
                <a href="/resumes/Ehsan_Ziaeikajbaf.pdf">Resume</a> |{" "}
                <a href="mailto:eziaeika@ucsd.edu">Email</a> |{" "}
                <a href="https://www.linkedin.com/in/ehsan-ziaeikajbaf-b57b55160/">Linkedin</a> |{" "}
                <a href="https://github.com/eziaeika">Github</a>
              </div>
              <div className="member-description">
                Ehsan is a 5th year undergraduate student in Eleanor Roosevelt College at UC San
                Diego. He is studying Electrical engineering with a focus on machine learning. He is
                interested in pursuing further research work on artificial intelligence and machine
                learning. He is very familiar with MATLAB, C programming, and Python through
                coursework at UCSD. He is also familiar with many concepts and theories of
                signal/image processing: Fourier analysis, convolution, LTI/LSI systems,
                linear-phase filter design.
              </div>
            </div>

            <div className="member">
              <div className="member-name">Nicholas Martin - B.S. Environmental Systems (Minor: Mechanics)</div>
              <div className="member-title">Cofounder - Principal Council Member - Alumni</div>
              <div className="member-picture-container">
                <img src="/team/nicholas.jpeg" />
              </div>
              <div className="resume-link">
                <a href="mailto:ntm002@ucsd.edu">Email</a>
              </div>
              <div className="member-description">
                Nicholas Martin is in his final year finishing his degree in Environmental Systems
                Earth Science with a Minor in Engineering Mechanics. He plans to utilize his machine
                learning knowledge gained from class and Triton-AI to develop effective robotics
                that address a variety of environmental challenges.
              </div>
            </div>



            <div className="member">
              <div className="member-name">Miro Markaravanes - B.S. Electrical Engineering</div>
              <div className="member-title">Website Developer - Alumni</div>
              <div className="member-picture-container">
                <img src="/team/miro.jpg" />
              </div>
              <div className="resume-link">
                <a href="/resumes/Miro_Markaravanes.pdf">Resume</a> |{" "}
                <a href="mailto:mma@ucsd.edu">Email</a> |{" "}
                <a href="https://www.linkedin.com/in/miro-markaravanes/">Linkedin</a> |{" "}
                <a href="https://github.com/minlite">Github</a>
              </div>
              <div className="member-description">
                Miro is a 5th undergraduate at UCSD studying Electrical Engineering with a focus in
                Machine Learning and Controls. He has previously interned for JPL, where he worked
                on the Lander Vision System for the Mars 2020 mission and also at Apple, where he
                worked as a part of the Core Location Frameworks team. On his free time Miro likes
                to snowboard.
              </div>
            </div>


            <div className="member">
              <div className="member-name">Jiayi Luo - B.S. Electrical Engineering</div>
              <div className="member-title">Technician Member - Alumni</div>

              <div className="member-picture-container">
                <img src="/team/jiayi.jpg" />
              </div>
              <div className="resume-link">
                <a href="mailto:jil818@ucsd.edu">Email</a>
              </div>
              <div className="member-description">
                Jiayi is a senior student major in Electrical Engineering specializing in Machine
                Learning and will continue study machine learning in UCSD for M.S. He is interested
                in machine learning, deep learning and computer vision and hopes to put what he
                learned from school into research.
              </div>
            </div>

            <div className="member">
              <div className="member-name">Yuhan Zhang - B.S. Electrical Engineering</div>
              <div className="member-title">Technician Member - Alumni</div>
              <div className="member-picture-container">
                <img src="/team/yuhan.jpg" />
              </div>
              <div className="resume-link">
</div>
              <div className="member-description">
                Yuhan is a graduate student at UC San Diego pursuing M.S. </div>
            </div>

            <div className="member">
              <div className="member-name">Serzh Yeranyan - B.S. Electrical Engineering</div>
              <div className="member-title">Technician Member - Alumni</div>
              <div className="member-picture-container">
                <img src="/team/serzh.jpg" />
              </div>
              <div className="resume-link">
              </div>
              <div className="member-description">
                Serzh is a 5th year Electrical Engineering major at UCSD. Since younger age, he has
                always been curious about how the world came to be. 
              </div>
            </div>


            <div className="member">
              <div className="member-name">David Soberanis Mechanical Engineering</div>
              <div className="member-title">Technician Member - Undergraduate</div>
              <div className="member-picture-container">
                <img src="/team/david.jpg" />
              </div>
              <div className="resume-link">
</div>
              <div className="member-description">
                David is a 4th year undergraduate student studying Computational Physics with a
                minor in Mechanical engineering and Computer Science at UCSD.
              </div>
            </div>



          </Article>
        )}
      </ThemeContext.Consumer>

      <Seo facebook={facebook} />

      <style jsx>{`
        .member {
          margin: 80px 0;

          .member-name {
            font-size: 1.5em;
          }

          .member-title {
            font-size: 1em;
            margin-bottom: 20px;
          }

          .member-picture-container {
            width: 200px;
            // height: 200px;
            margin-bottom: 20px;

            img {
              width: 100%;
              // height: 100%;
              // object-fit: cover;
            }
          }

          .resume-link {
            a {
              color: #007cff;
            }
          }
        }
      `}</style>
    </React.Fragment>
  );
};

ContactPage.propTypes = {
  data: PropTypes.object.isRequired
};

export default ContactPage;

//eslint-disable-next-line no-undef
export const query = graphql`
  query TeamQuery {
    site {
      siteMetadata {
        facebook {
          appId
        }
      }
    }
  }
`;
